export abstract class MethodCall {
    public args: any[];
    public accessPath: string;
}
